import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';

/* Floating "Install App" button — shows when the browser fires `beforeinstallprompt`.
 * Auto-hides if the user dismisses or already installed (display-mode: standalone). */
export const PWAInstallPrompt = () => {
  const [promptEvent, setPromptEvent] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('pwa_install_dismissed') === '1');

  useEffect(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isStandalone) return undefined;

    const handler = (e) => {
      e.preventDefault();
      setPromptEvent(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!promptEvent || dismissed) return null;

  const install = async () => {
    promptEvent.prompt();
    const { outcome } = await promptEvent.userChoice;
    if (outcome === 'dismissed') {
      localStorage.setItem('pwa_install_dismissed', '1');
      setDismissed(true);
    }
    setPromptEvent(null);
  };

  const dismiss = () => {
    localStorage.setItem('pwa_install_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-50 bg-white border-2 border-primary shadow-lg p-4 flex items-start gap-3"
      data-testid="pwa-install-prompt"
    >
      <img src="/icons/icon-192.png" alt="" className="w-12 h-12 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold">Install 360 Carexport</p>
        <p className="text-[11px] text-muted-foreground mb-2">Add to home screen for faster access &amp; offline use</p>
        <div className="flex gap-2">
          <Button size="sm" onClick={install} className="text-xs h-7 px-3" data-testid="pwa-install-btn">Install</Button>
          <Button size="sm" variant="ghost" onClick={dismiss} className="text-xs h-7 px-3" data-testid="pwa-install-dismiss">Not now</Button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
